module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n    Estimated days for difficulty retarget.\n  ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_c('p', [_vm._v("\n      Estimated next difficulty. The 12 hour hashrate average is used to make a prediction about upcoming blocks in the period.\n    ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("BTC")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.date('BTC')))]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.days('BTC')) + "\n          "), _c('small', [_vm._v("(" + _vm._s(_vm.left('BTC')) + " blk)")])]), _vm._v(" "), _c('td', [(_vm.next_pct('BTC', true) > 1) ? _c('i', {
    staticClass: "fa fa-chevron-up up"
  }) : _vm._e(), _vm._v(" "), (_vm.next_pct('BTC', true) < 1) ? _c('i', {
    staticClass: "fa fa-chevron-down down"
  }) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.next('BTC')) + "\n        ")])]), _vm._v(" "), _vm._m(2, false, false)])]), _vm._v("\n    * On November 13th 2017 BCH switches to a faster changing difficulty algorithm which makes it impractical to make predictions about its behaviour.\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-retarget"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v("Coin")]), _vm._v(" "), _c('th', [_vm._v("Date (UTC 24h)")]), _vm._v(" "), _c('th', [_vm._v("Remaining")]), _vm._v(" "), _c('th', [_vm._v("Change")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("BCH *")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a584ab9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/retarget.vue
// module id = 544
// module chunks = 1